module.exports = __webpack_public_path__ + "static/media/voter_registration.aec9e665.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/voter_registration.pdf
// module id = 2165
// module chunks = 0